import React from 'react';

import { Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles((theme) => ({
  paginator: {
    justifyContent: 'space-between',
    padding: theme.spacing(1, 0)
  },
  paginationButton: {
    height: theme.spacing(0.5),
    textTransform: 'none',
    fontSize: 12
  }
}));

type FooterProp = {
  onNext: () => void;
  onPrevious: () => void;
  showNext: boolean;
  showPrev: boolean;
};

const Footer: React.FC<FooterProp> = ({
  onNext,
  onPrevious,
  showNext,
  showPrev
}: FooterProp) => {
  const classes = useStyles();

  return (
    <div className={classes.paginator}>
      {showPrev ? (
        <Button
          variant={'text'}
          data-testid="my-utilization-prev"
          className={classes.paginationButton}
          onClick={onPrevious}
        >
          <FormattedMessage id="insights.timeUtilizationChart.prev" />
        </Button>
      ) : (
        <span></span>
      )}
      {showNext ? (
        <Button
          variant={'text'}
          data-testid="my-utilization-next"
          className={classes.paginationButton}
          onClick={onNext}
        >
          <FormattedMessage id="insights.timeUtilizationChart.next" />
        </Button>
      ) : (
        <span></span>
      )}
    </div>
  );
};

export default React.memo(Footer);
